var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4153 11.6488V5.75406C11.4153 3.31238 13.4679 1.33301 16 1.33301C18.5321 1.33301 20.5847 3.31238 20.5847 5.75406V11.6488M5.30229 22.6663H26.6977M7.05665 29.333H24.9434C26.7172 29.333 28.1185 27.8818 27.9921 26.1756L26.9005 11.4388C26.7862 9.89643 25.4553 8.70143 23.8518 8.70143H8.14825C6.5447 8.70143 5.21378 9.89643 5.09953 11.4388L4.00792 26.1756C3.88155 27.8818 5.28284 29.333 7.05665 29.333Z",
    stroke: "#7F56D9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shoppingBag.4a51ce7df454ad8b4ff2adf8241b147c.svg";
export { ForwardRef as ReactComponent };